import React from 'react';
import TopMenu from '../../contexts/TopMenu';
import '../../styles/Trends.css';

function Trends({ email, onLogout }) {
  return (
    <div className="dashboard-root">
      <TopMenu pageTitle="Trends Dashboard" email={email} onLogout={onLogout} />
      <div className="dashboard-container">
        <div className="trends-content">
          <h2>Market Trends</h2>
          <p>Coming soon: Industry trends and insights.</p>
        </div>
      </div>
    </div>
  );
}

export default Trends; 